import { useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import endpoints from '../../../API/endpoints'
import callAPI from '../../../API/callSecureAPI'
import { CardData } from '../../components/MetricsCards/types'

const FIVE_MINUTES = 1000 * 60 * 5

export const useGetTppImpactMetricsQuery = () => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    // @ts-expect-error store is not typed properly
    const strategyId = useSelector((state) => state.strategy?._id)

    const getTppImpactMetrics = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })

            const { url, method } = endpoints.getTppImpactMetrics

            const response = await callAPI(url + strategyId, method, token)

            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    return useQuery<CardData[]>(['tppImpactMetrics', strategyId], getTppImpactMetrics, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!strategyId,
        cacheTime: FIVE_MINUTES,
        staleTime: FIVE_MINUTES,
        retry: 3,
    })
}
